export default function Horizon() {
  return <div className="border-t border_primary " />;
}
